export const ItemTypes = {
  REAGENT: "REAGENT",
  SPECIMEN: "SPECIMEN",
  TOOL: "TOOL",
  EFFECT: "EFFECT",
};
